import { FC } from 'react';
import styled from '@emotion/styled';
import Image from '@base/Image';
import { Spacings, Fonts } from '@styles/index';
import Button from '@base/Button/Button';
import Paper from '@base/Paper/Paper';
import { DST } from './utils';
import useDstClickHandlers from './useDstClickHandlers';

const Container = styled(Paper)`
  position: relative;
  padding: ${Spacings.SPACING_10B};
  display: flex;
`;

const ContentDiv = styled.div`
  margin-right: ${Spacings.SPACING_10B};
  flex: 1;
`;

const Heading = styled.div`
  font-size: ${Fonts.H3};
  font-weight: ${Fonts.HEAVY};
  line-height: 28px;
  color: var(--color-text-primary);
`;

const Point = styled.div`
  margin-top: ${Spacings.SPACING_4B};
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  font-size: ${Fonts.H6};
  line-height: ${Spacings.SPACING_5B};
  color: var(--color-text-primary);
  margin-left: ${Spacings.SPACING_3B};
`;

const StyledBtn = styled(Button)`
  width: 139px;
  height: 46px;
  margin-top: ${Spacings.SPACING_10B};
`;

export const getBulletPoints = (data) => {
  return [
    {
      imgSrc: '/dst/bullet-point-1.svg',
      text: `${data.questionCount} quick questions`
    },
    {
      imgSrc: '/dst/bullet-point-2.svg',
      text: `${data.testDuration} minutes to attempt`
    },
    {
      imgSrc: '/dst/bullet-point-3.svg',
      text: 'Scholarship leaderboard after the test'
    }
  ];
};

type UnattemptedProps = {
  data: DST;
  goalUID: string;
  goalSlug: string;
  goalName: string;
};

const Unattempted: FC<UnattemptedProps> = ({
  data,
  goalUID,
  goalSlug,
  goalName
}) => {
  const bulletPoints = getBulletPoints(data.data[0]);
  const { takeTest } = useDstClickHandlers({
    goalUID,
    goalSlug,
    goalName,
    lps: 'Tests'
  });

  return (
    <Container>
      <ContentDiv>
        <Heading>Get upto 50% discount with our scholarship test</Heading>
        {bulletPoints.map(({ imgSrc, text }) => {
          return (
            <Point key={text}>
              <Image src={imgSrc} height={20} width={20} alt="dst-points" />
              <Text>{text}</Text>
            </Point>
          );
        })}
        <StyledBtn
          // @ts-ignore
          label="Take test"
          variant="filled"
          color="black"
          onClick={takeTest}
        />
      </ContentDiv>
      <Image src="/dst/trophy.svg" height={182} width={273} alt="dst-trophy" />
    </Container>
  );
};

export default Unattempted;
